import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SaveButton,
  DeleteButton,
  Toolbar, TextField, DateField
} from 'react-admin';
import {Card, CardContent, Typography, makeStyles, Box} from '@material-ui/core';
import LogicInput from './logicInput';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  form: {
    flex: 1,
    marginRight: 0,
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
  preview: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '350px',
    },
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 0,
  }
}));

const CustomToolbar = (props) => {
  const classes = useStyles();
  
  return (
    <Toolbar {...props} className={classes.toolbar}>
      <SaveButton label="Save Changes" />
      <DeleteButton />
    </Toolbar>
  );
};

const QrCodeEdit = (props) => {
  const classes = useStyles();
  
  return (
      <Card>
        <CardContent>
        <Edit {...props} title="Edit QR Code">
          <SimpleForm
              className={classes.form}
              toolbar={<CustomToolbar/>}
              redirect="show"
          >
            <Box className={classes.field}>
              <Typography className={classes.fieldLabel} variant="h6">QR Code Hash URL</Typography>
              <Typography className={classes.fieldValue}>
                <TextField source="url"/>
              </Typography>
            </Box>

            <Box className={classes.field}>
              <Typography className={classes.fieldLabel} variant="h6">Name</Typography>
              <Typography className={classes.fieldValue}>
                <TextInput source="name" fullWidth/>
              </Typography>
            </Box>

            <Box className={classes.field}>
              <Typography className={classes.fieldLabel}>Created At</Typography>
              <Typography className={classes.fieldValue}>
                <DateField source="created_at" showTime/>
              </Typography>
            </Box>
            <LogicInput />
          </SimpleForm>
        </Edit>
        </CardContent>
      </Card>
  );
};

export default QrCodeEdit;